var map = {
	"./assessment.png": 93767,
	"./authorization.png": 62325,
	"./baocao.png": 85546,
	"./baocaohc.png": 27132,
	"./baocaonhansu.png": 27558,
	"./blue-icon.png": 7686,
	"./caidatthongso.png": 24674,
	"./calendar.png": 72461,
	"./capsovanthu.png": 41195,
	"./categories.png": 55950,
	"./cd-blue.png": 96274,
	"./checklist.png": 69667,
	"./classification.png": 37207,
	"./close-icon.png": 9130,
	"./company.png": 48386,
	"./customer-service.png": 60590,
	"./dangkycc.png": 95627,
	"./datphonghop.png": 43182,
	"./datxe.png": 10199,
	"./department.png": 17341,
	"./dv-hc-icon.png": 3782,
	"./efficiency.png": 47318,
	"./emailsetting.png": 60773,
	"./giaitrinh.png": 86677,
	"./handbook.png": 84635,
	"./khoahoc.png": 97586,
	"./lambu.png": 13017,
	"./learning-hub.png": 59487,
	"./linkuv.png": 89543,
	"./listemoji.png": 10274,
	"./loai-vanthu.png": 98483,
	"./menu-button.png": 93575,
	"./mybhs-logo.png": 14354,
	"./next-level.png": 24249,
	"./notification-button.png": 50944,
	"./personal-information.png": 99899,
	"./profile.png": 67635,
	"./qrcode.png": 2236,
	"./quanlyroom.png": 72762,
	"./quanlyxe.png": 56759,
	"./refresh.png": 82754,
	"./register.png": 70035,
	"./send-data.png": 27953,
	"./sign-out.png": 30354,
	"./sukien.png": 91884,
	"./system-administration.png": 10874,
	"./tantuyen.png": 89687,
	"./team-work.png": 85356,
	"./technical-support.png": 84322,
	"./time-management.png": 5196,
	"./totrinh.png": 30190,
	"./truyenthong-vanhoa.png": 11941,
	"./ttsuser.png": 32807,
	"./ungvien.png": 97590,
	"./user-con.png": 24634,
	"./userlogin.png": 35635,
	"./vanthu.png": 68545,
	"./workfollow.png": 54936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70804;